/**
 * FAQ Accordion
 * Shopify Dawn compatible
 * Vanilla JS
 */

(function () {
  'use strict';

  function initFAQ(section) {
    if (!section || section.dataset.faqInitialized === 'true') {
      return;
    }

    const accordion = section.querySelector('[data-faq-accordion]');

    if (!accordion) {
      return;
    }

    section.dataset.faqInitialized = 'true';

    const allowMultiple = section.dataset.allowMultiple === 'true';
    const openFirst = section.dataset.openFirst === 'true';

    /**
     * Get all FAQ items
     */
    const getItems = () => {
      return Array.from(
        accordion.querySelectorAll('[data-faq-item]')
      );
    };

    /**
     * Open an FAQ item
     */
    const openItem = (item) => {
      if (!item) return;

      const trigger = item.querySelector('[data-faq-trigger]');
      const answer = item.querySelector('[data-faq-answer]');

      if (!trigger || !answer) {
        return;
      }

      /*
       * If multiple FAQs are not allowed,
       * close all other FAQs first.
       */
      if (!allowMultiple) {
        getItems().forEach((otherItem) => {
          if (otherItem !== item) {
            closeItem(otherItem);
          }
        });
      }

      item.classList.add('is-open');

      trigger.setAttribute('aria-expanded', 'true');

      answer.hidden = false;
      answer.setAttribute('aria-hidden', 'false');
    };

    /**
     * Close an FAQ item
     */
    const closeItem = (item) => {
      if (!item) return;

      const trigger = item.querySelector('[data-faq-trigger]');
      const answer = item.querySelector('[data-faq-answer]');

      if (!trigger || !answer) {
        return;
      }

      item.classList.remove('is-open');

      trigger.setAttribute('aria-expanded', 'false');

      answer.hidden = true;
      answer.setAttribute('aria-hidden', 'true');
    };

    /**
     * Toggle FAQ item
     */
    const toggleItem = (item) => {
      const trigger = item.querySelector('[data-faq-trigger]');

      if (!trigger) {
        return;
      }

      const isOpen =
        trigger.getAttribute('aria-expanded') === 'true';

      if (isOpen) {
        closeItem(item);
      } else {
        openItem(item);
      }
    };

    /**
     * Event delegation
     *
     * This is intentionally attached to the accordion
     * instead of individual buttons.
     */
    accordion.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-faq-trigger]');

      if (!trigger || !accordion.contains(trigger)) {
        return;
      }

      const item = trigger.closest('[data-faq-item]');

      if (!item) {
        return;
      }

      event.preventDefault();

      toggleItem(item);
    });

    /**
     * Set initial state
     */
    getItems().forEach((item) => {
      const trigger = item.querySelector('[data-faq-trigger]');
      const answer = item.querySelector('[data-faq-answer]');

      if (!trigger || !answer) {
        return;
      }

      /*
       * Always start closed.
       */
      trigger.setAttribute('aria-expanded', 'false');

      answer.setAttribute('aria-hidden', 'true');

      answer.hidden = true;

      item.classList.remove('is-open');
    });

    /**
     * Open first FAQ if enabled
     */
    if (openFirst) {
      const firstItem = getItems().find((item) => {
        return (
          item.querySelector('[data-faq-trigger]') &&
          item.querySelector('[data-faq-answer]')
        );
      });

      if (firstItem) {
        openItem(firstItem);
      }
    }
  }

  /**
   * Initialize all FAQ sections
   */
  function initAllFAQSections(root) {
    const scope = root || document;

    const sections = scope.querySelectorAll(
      '.faq-accordion-section'
    );

    sections.forEach((section) => {
      initFAQ(section);
    });
  }

  /**
   * Initial page load
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initAllFAQSections(document);
      }
    );
  } else {
    initAllFAQSections(document);
  }

  /**
   * Shopify Theme Editor
   */
  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initAllFAQSections(event.target);
    }
  );

})();